import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { usePageImpressions } from './hooks/use-page-impressions';

export const PageImpressionsObserver: FC = () => {
  usePageImpressions();
  return <Outlet />;
};
